import type { ErrorCode } from '../pairing/driver';
import { HudPanel } from './hud-panel';

const MESSAGES: Record<ErrorCode, string> = {
  no_hash: 'No pairing URL detected. Scan the QR from your terminal.',
  malformed_hash: 'The pairing URL is malformed. Re-scan the QR.',
  wasm_load_failed: 'Failed to load cryptography module.',
  ws_open_failed: 'Cannot connect to the relay. Check your network.',
  unknown_session: 'This pairing session no longer exists. Re-scan the QR.',
  room_busy: 'Another browser is already paired with this session.',
  rate_limited: 'Too many attempts. Wait a minute and re-scan.',
  handshake_failed: 'Pairing failed. Likely a wrong PIN — re-scan the QR.',
  handshake_timeout: 'The agent did not answer in time. Check your network and re-scan the QR.',
  room_expired: 'The pairing window expired. Re-scan the QR.',
  reconnect_denied: 'The agent denied reconnect (session forgotten or expired). Re-scan the QR.',
  forgotten: 'The agent no longer recognises this browser (session forgotten). Re-scan the QR.',
  expired: 'The reconnect session has expired. Re-scan the QR.',
  unreachable: 'The agent is unreachable. Check your network and try again.',
  disconnected: 'The connection dropped.',
};

export function ErrorScreen(props: { code: ErrorCode; detail?: string; onRetry: () => void }) {
  return (
    <main class="flex min-h-screen items-center justify-center p-6">
      <HudPanel class="max-w-md text-center">
        <h1 class="hud-mono text-lg font-semibold uppercase tracking-[0.22em] text-crit">Error</h1>
        {/* The raw code is real diagnostic signal, not a duplicate of the human
            message below — never suppress it in favour of the friendlier text. */}
        <p class="hud-mono mt-1 text-[0.5938rem] uppercase tracking-[0.3em] text-faint">{props.code}</p>
        <p class="mt-4 text-sm text-muted">{MESSAGES[props.code]}</p>
        {props.detail && (
          <p class="hud-mono mt-2 text-xs text-faint">{props.detail}</p>
        )}
        <button type="button" onClick={props.onRetry} class="hud-btn mt-4">
          Try again
        </button>
      </HudPanel>
    </main>
  );
}
